module.exports = __webpack_public_path__ + "media/images/home-6dac22165ff9349787a7de378622c5fa.png";